import { authActionTypes } from "../actions/actionTypes";
import {HttpNode } from "../../axiosInstances";
import md5 from 'md5';
import Terminos from "../../components/HomePage/TerminosCondiciones/Terminos";
import { LaptopWindows } from "@material-ui/icons";

export const login = (user, password, history) => {
    var sesion = 0;
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    localStorage.removeItem("sesiones");//nuevo
    localStorage.removeItem("time_token");//nuevo

    const usu = localStorage.getItem("username");
    const ses = localStorage.getItem("sesiones");
    return dispatch => {
        dispatch(authStart());
        //HttpNode.post(`/seticap/api/users/login`,  {usr: user, pwd: md5(password)} )
        HttpNode.post(`/seticap/api/users/login`,  {usr: user, pwd: password} )
            .then(response => {
                if(response.data.status === 'success'){

                    if (user !== usu && ses !== 1)
                    {
                        localStorage.setItem("user", response.data.user.name);
                        localStorage.setItem("username", user);
                        sesion = 1;                        
                        localStorage.setItem("sesiones", sesion);
                        localStorage.setItem("time_token", new Date());

                        // LA - nuevos atributos en cache
                        localStorage.setItem("user_id", response.data.user.id);
                        localStorage.setItem("email", response.data.user.email);
                        localStorage.setItem("key_expired", response.data.user.key_expired);
                        if (response.data.user.key_expired) {
                            localStorage.setItem("token", md5(password));  
                            response.data.token = md5(password);
                            dispatch(authFinished({token: md5(password), user: response.data.user.name}));
                        } else {
                            localStorage.setItem("token", password);  
                            response.data.token = password;
                            dispatch(authFinished({token: password, user: response.data.user.name}));
                        }
                        //console.log('OKLog');

                        // LA - Agregamos al cache el nuevo token de usuario obtenido
                        localStorage.setItem("token_app", response.data.user.token);

                        // Aceptación de terminos y condiciones
                        var m_confirmado = response.data.user.fecha_confirmacion
                        if(m_confirmado == null) {
                            // Lanzamos la ventana de aceptación terminos y condiciones si el usuario no los ha aceptado
                            Terminos(response.data.user.id);
                            localStorage.clear();
                            window.localStorage.clear();
                        }
                         else if (response.data.user.key_expired == false)
                        {
                        // LA - Si el usuario no tiene la clave expirada, lo redirigimos al dashboard
                            history.push("/dashboard/");         
                            window.location.reload(true);
                        }
                        else 
                        // LA - Si el usuario tiene la clave expirada, lo redirigimos a cambiar la contraseña
                             window.location="/auth/change-contrasena/"


                        // LA - Refrescamiento requerido para la puesta en cache del nuevo token                        
                        //window.location.reload(true);
                    }
                    else{//// console.log('Usuario ya ingreso');
                        //dispatch(authError("Usuario ya ingreso" + "USUARIO:" + response.data.user.name + "SESION" + ses));
                        dispatch(authError("Ya existe un inicio de sesión activo"));
                        localStorage.removeItem('sesiones');
                        dispatch(logout());
                    }
                }else if(response.data.status === 'INVALID'){
                    //// console.log('Usuario/Contraseña incorrectos');
                    dispatch(authError("Usuario/Contraseña incorrectos"));

                }else if(response.data.status === 'EXPIRED'){
                    //// console.log('La cuenta ha expirado');
                    dispatch(authError("La cuenta ha expirado"));

                }else if(response.data.status === 'DISABLED'){
                    //// console.log('Cuenta de usuario Inactiva');
                    dispatch(authError("Cuenta de usuario Inactiva"));

                } else {
                    dispatch(authError("Ha ocurrido un error, por favor intenta más tarde"));
                    //window.location="/auth/change-contrasena/"
                }
            });
    };
};

const authStart = () => {
    return {
        type: authActionTypes.LOGIN_START
    };
};

const authFinished = auth => {
    return {
        type: authActionTypes.LOGIN_SUCCESS,
        payload: auth
    };
};

const autoLogin = () => {
    return {
        type: authActionTypes.LOGIN_INITIAL_CHECK
    };
};

const authError = error => {
    return {
        type: authActionTypes.LOGIN_ERROR,
        payload: error
    };
};

const authCheckLogin = () => {
    return dispatch => {
        dispatch(autoLogin());
        const token = localStorage.getItem("token");
        const user = localStorage.getItem("username");
        const sesion = localStorage.getItem("sesiones");
         if (token) {
            //  HttpNode.get(`/seticap/api/users/${user}/${token}/`).then(({ data }) => {
            //      if (data.status === 'success') {
            //         const user = localStorage.getItem("user");
            //          dispatch(authFinished({ token, user }));
            //      } else {
            //          dispatch(logout());
            //      }
            //  });
         }else{
             dispatch(logout());
         }
    };
};
const logout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    localStorage.removeItem("sesiones");//nuevo
    localStorage.removeItem("time_token");//nuevo
    localStorage.clear();
    window.localStorage.clear();
    return {
        type: authActionTypes.LOGOUT
    };
};

export default {
    login: login,
    checkLogin: authCheckLogin,
    logout: logout
};
